import { ResourceHeaders } from '..'
import {
  AlertsHeader,
  DateHeader,
  IdHeader,
  MarketPricesHeader,
  PhotoHeader,
  TextHeader,
  VehicleHeader,
  VehicleStatusHeader,
} from '../../headers'
import { Helpers } from '../../helpers'
import { CellType, TableCellHeader } from '@/components/dataTables/cell'
import { extendsObj } from '@/utils/vuetify/helpers'

export const headers: ResourceHeaders = [
  {
    ...IdHeader,
    text: 'Nº',
    value: '@',
    options: {
      expandOff: true,
      action: {
        edit: Helpers.linkedModel,
      },
    },
  },
  { ...AlertsHeader, text: 'Alerta', value: 'stockPriceAlert', sortable: true },
  { ...PhotoHeader, text: 'Foto', value: '@' },
  extendsObj<TableCellHeader>({
    text: 'Stock',
    value: '@',
    options: {
      path: 'auto.name',
      trigger: item => Helpers.linkedModel({ constructor: { name: 'SupervisorStockPublish' }, ...item }),
    },
  }, VehicleHeader),
  { ...VehicleStatusHeader, text: 'Estado stock', value: 'stockStatus' },
  { ...TextHeader, text: 'Llave', value: 'keyIdentifier.keyId', width: 60 },
  { ...TextHeader, text: 'Kilometraje', value: 'kms' },
  { ...TextHeader, text: 'Dueños', value: 'owners' },
  { ...DateHeader, text: 'Fecha último precio', value: 'created', width: 180 },
  {
    ...MarketPricesHeader,
    text: 'Precio y descuento',
    value: 'priceDiscount',
    width: 240,
  },
  {
    ...MarketPricesHeader,
    text: 'Recibidos',
    value: 'received',
    width: 180,
    options: {
      component: CellType.text,
      options: {
        align: 'start',
      },
    },
  },
  {
    ...MarketPricesHeader,
    text: 'Utilidad proyectada',
    value: 'utility',
    width: 130,
    options: {
      component: CellType.text,
      options: {
        align: 'center',
      },
    },
  },
  {
    ...MarketPricesHeader,
    text: 'Días',
    value: 'stockInformation',
    width: 150,
    options: {
      component: CellType.text,
      options: {
        align: 'start',
      },
    },
  },
]

export default function (): ResourceHeaders {
  return headers
}
